module.exports = __webpack_public_path__ + "media/images/logo_mailer-b2accec4f1db5867c3264086648f06ef.svg";